import React, { memo, forwardRef } from "react";
const SvgFloor = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={11} y={11} fill="#DBDBDB" rx={2} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M4 8a1 1 0 011-1h8a1 1 0 110 2H6v8a1 1 0 11-2 0V8zM28 8a1 1 0 00-1-1h-8a1 1 0 100 2h7v8a1 1 0 102 0V8z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgFloor.displayName = "SvgFloor";
const MemoForwardRef = memo(SvgFloor);
export default MemoForwardRef;
